import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	allSites: {
		id: 'navigation.global-shortcuts.all-sites',
		defaultMessage: 'All sites',
		description:
			'The text is shown as a menu item label in the global shortcuts expanded menu. This item displays all available Atlassian sites that the user has access to.',
	},
	closeButtonAriaLabel: {
		id: 'navigation.global-shortcuts.menu-expand-item.close-button-aria-label',
		description:
			'Accessibility label for the close button that collapses the global shortcuts expanded menu. Assistive technologies use this label to announce the button purpose to users.',
		defaultMessage: 'Close',
	},
	siteAriaLabel: {
		id: 'navigation.global-shortcuts.menu-expand-item.site-aria-label',
		description:
			'Accessibility label for individual site items in the global shortcuts expanded menu. The placeholder {name} will be substituted with the site name (e.g., "hello" or "product-fabric"). Example: "hello site". Assistive technologies use this label to identify each site.',
		defaultMessage: '{name} site',
	},
});
